/// <reference path="../../../tools/typings/tsd.d.ts"/>
/// <reference path="./address-interfaces.ts"/>

// NOT YET IN USE
//
namespace DealerwareWebServices {
    "use strict";

    export class Address implements IDealerwareAddress {
        // Properties
        public static $inject: string[] = [
            '$q',
            '$timeout',
            //'AddressModel',
        ];

        private _id: number;
        public line1: string;
        public line2: string;
        public city: string;
        public state: string;
        public zip: string;
        public latitude: string;
        public longitude: string;

        // Constructor
        constructor(public $q: any,
                    public $timeout: any
                    //public AddressModel: any
        ) {}


        get id () : number {
            return this._id;
        }

        set id (id: number) {
            if (id !== this._id) {
                this.clear();
            }

            this._id = id;
        }

        // Methods
        public clear() : void {
            //this.clearVehicleDetails();
        }

        public save(id?: number) : ng.IPromise<{}> {
            var deferred = this.$q.defer();
            return deferred.promise;
        }

        public add() : ng.IPromise<{}> {
            var deferred = this.$q.defer();
            return deferred.promise;
        }

        public update(id?: number) : ng.IPromise<{}> {
            var deferred = this.$q.defer();
            return deferred.promise;
        }

        public delete(id?: number) : ng.IPromise<{}> {
            var deferred = this.$q.defer();
            return deferred.promise;
        }

        public load (id?: number) : ng.IPromise<{}> {

            var that = this;
            var deferred = this.$q.defer();

            /*

            if (id) { this.vehicleId = id; }

            if (!this.vehicleId) {
                _deferred.reject({response: {data: {message: 'Vehicle ID is undefined'}}});
            } else {
                this.DealerwareVehicleModel.loadVehicleDetails({
                    params: {
                        id: _self.vehicleId,
                        include_location: true
                    },
                    successCallback: function(returnValue: any, response: any) {
                        _self.vehicleDetails = returnValue;
                        _deferred.resolve({ returnValue: returnValue, response: response });
                    },
                    errorCallback: function(response: any) {
                        console.log("DealerwareVehicleModel.get ERROR: ", response);
                        _deferred.reject({ response: response });
                    }
                });
            }
            */

            return deferred.promise;
        }
    }

    getDealerwareWebServicesModule().service('$dealerwareAddress', Address);
}
